export default "__VITE_ASSET__DgS9WoNw__"